import React from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'

const NextPreviousButton = (props) => {
    const {page,nextPage,prePage,isLoading, verifyPrepay, walletButtonShow}=props
    return (
        <div className="clearfix d-flex align-items-center justify-content-end">
       {page!='1' && page!='5'  && <button
          className="btn btn-primary me-2 btn-sm text-nowrap text-white"
          onClick={prePage}
          type="button"
        >
          <i className="fa fa-arrow-left"></i>{' '}
          <span className="d-none d-sm-inline-block">
            Previous{' '}
          </span>
        </button>}

        <button
          className="btn btn-primary text-nowrap btn-sm"
          onClick={nextPage}
          disabled={isLoading}
          type="submit"
        >
          <span className="d-none d-sm-inline-block">
            {(verifyPrepay == '1' && page == 3 && walletButtonShow) ? 'Proceed to Pay' : `Next${' '}` }
          </span>{' '}
          <i className="fa fa-arrow-right"></i>
        </button>
      </div>
    )
}

NextPreviousButton.propTypes = {
    page: PropTypes.string,
    nextPage: PropTypes.func,
    prePage: PropTypes.func,
    isLoading:PropTypes.boolean,
    verifyPrepay: PropTypes.string,
    walletButtonShow: PropTypes.bool
}

NextPreviousButton.defaulProps = {
    dispatch: noop,
    page:'0',
    isLoading:false,
    verifyPrepay: '',
    walletButtonShow: false
}

export default NextPreviousButton
